module.exports = __webpack_public_path__ + "static/media/chat_background_dark.7bc7a5c0.png";